// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"179":"9af93c8f","664":"52d55eb1","897":"b74a7070"}[chunkId] + ".css";
};